<div class="custom-alert-container">
    <h5>{{ data.titulo }}</h5> <!-- Mostrar el título -->
    <p>{{ data.message }}</p> <!-- Mostrar el mensaje -->

    <div class="dialog-actions">
        <button mat-button (click)="onClose()">Cerrar</button> <!-- Botón de cierre -->
    </div>
</div>